import './scrollTrigger';
import { gsap } from 'gsap';
import { getBreakpoint, normalizeString } from './_utils';
import _debounce from 'lodash/debounce';
const className = 'hotelSearchBar';

const selectors = {
	hotelSearchBar: `.${className}`,
	clearButton: 'button.icon-close',
	input: '.textInput__field',
	results: '.hotelSearchBar-results',
	tabbedHeroContent: '.TabbedHero-content',
	tabbedHeroTab: '.TabbedHero-tab',
	headingContainer: '.TabbedHero-headingContainer',
	tabbedHeroIcons: '.TabbedHero-icons',
	noResults: '.no-results',
	group: '.group',
	groupTitle: '.group-title span.title',
	innerResults: '.results',
	groupResults: '.group-results',
	alertBanner: '.AlertBanner',
};

const resetTabHeroIcons = ($searchBar, $tabbedHero, $tabbedHeroIcons) => {
	window.requestAnimationFrame(() => {
		if ($searchBar.parents(selectors.tabbedHeroTab).css('opacity') === '1') {
			const visible = $searchBar.hasClass('active');
			if (
				(visible && $tabbedHeroIcons.css('position') !== 'fixed') ||
				(!visible && $tabbedHeroIcons.css('position') === 'fixed')
			) {
				let timeout = visible ? 0 : 200;
				setTimeout(() => {
					const selectedTab = $tabbedHeroIcons[0].contains(document.activeElement)
						? document.activeElement
						: null;
					$tabbedHero.append($tabbedHeroIcons);
					$tabbedHeroIcons.css({
						position: '',
						top: '',
						left: '',
						bottom: '',
						'z-index': '',
					});
					if (visible) {
						const heroRect = $tabbedHeroIcons[0].getBoundingClientRect();
						const isLarge = window.innerWidth >= 1100;
						const banner = document.querySelector(selectors.alertBanner);
						const offset = isLarge && banner ? banner.offsetHeight : 0;
						$searchBar.after($tabbedHeroIcons);
						$tabbedHeroIcons.css({
							position: 'fixed',
							top: heroRect.top + window.scrollY - offset,
							bottom: 'auto',
							left: 0,
							'z-index': 1,
						});
					}
					if (selectedTab) {
						selectedTab.focus({ preventScroll: true });
					}
				}, timeout);
			}
		}
	});
};
const locale = document?.getElementsByTagName('html')?.[0].attributes?.lang?.value || 'en';
const getResultHtml = (link, propertyName, country, interactionName, interactionType) => {
	let interactionDetail = '';
	if (interactionName && interactionType) {
		const pathParts = link?.split('/') || [];
		//set 1 layer deeper for private residence properties or jet journeys
		let residencePropertyIdLoc =
			pathParts.includes('private_residences') || pathParts.includes('privatejet') ? 7 : 6;
		const propertyIdLoc = pathParts.includes('content')
			? residencePropertyIdLoc
			: locale === 'en'
			? 1
			: 2;
		interactionDetail = pathParts.length > propertyIdLoc ? pathParts[propertyIdLoc] : undefined;
	}

	const innerHtml = `
		<div class="hotel ty-c3">${window.FS.resizeBeverlyWilshire(propertyName)}</div>
		${country ? `<div class="country ty-c4">${country}</div>` : ''}`;

	if (interactionDetail) {
		const el = document.createElement('a');
		el.classList.add('hotelSearchBar-result');
		el.href = link;
		el.innerHTML = innerHtml;
		window.FS.Tealium.trackInteraction(
			interactionType,
			interactionName,
			interactionDetail,
			$(el)
		);
		return el.outerHTML;
	}

	return `<a class="hotelSearchBar-result" href="${link}">${innerHtml}</a>`;
};
let lastq = [];
const search = (q, data, groupings, $results, interactionName, interactionType, i) => {
	q = normalizeString(q);
	if (lastq[i] !== q) {
		lastq[i] = q;
		data = data || {};
		const results = [];
		const groupingsResults = [];
		let groupingsMatch = false;
		if (groupings && groupings.length) {
			for (let i = 0; i < groupings.length; i++) {
				groupingsResults.push([]);
			}
		}

		const tagMap = data.tagMap || {};
		if (data.properties) {
			data.properties.forEach(property => {
				property = property || {};
				let matches = !q;
				if (property.country) {
					matches =
						matches ||
						property.country.includes(q) ||
						normalizeString(tagMap[property.country]).includes(q);
				}
				if (!property.normalizedName && property.normalizedName !== '') {
					property.normalizedName = normalizeString(property.propertyName);
					if (property.searchTerms && property.searchTerms.length) {
						for (let i = 0; i < property.searchTerms.length; i++) {
							var searchTerm = normalizeString(property.searchTerms[i]);
							if (searchTerm) {
								property.normalizedName += ` ${searchTerm}`;
							}
						}
					}
					if (property.normalizedName) {
						const p = document.createElement('p');
						p.innerHTML = property.normalizedName;
						property.normalizedName = p.innerText;
					} else {
						property.normalizedName = '';
					}
				}
				matches = matches || property.normalizedName.includes(q);
				let html;
				if (matches) {
					html = getResultHtml(
						property.link || '#',
						property.propertyName,
						tagMap[property.country],
						interactionName,
						interactionType
					);
					results.push(html);
				}
				if (groupings && groupings.length && property.features) {
					groupings.forEach((grouping, i) => {
						let tags =
							grouping && grouping.getAttribute('data-tag')
								? grouping.getAttribute('data-tag').split(',')
								: [];
						let matchesTag =
							matches ||
							normalizeString(
								grouping.querySelector(selectors.groupTitle).innerText
							).includes(q);
						let propertyHasTag = false;
						tags.forEach(tag => {
							propertyHasTag = propertyHasTag || property.features.includes(tag);
							matchesTag =
								matchesTag ||
								tag.includes(q) ||
								normalizeString(tagMap[tag]).includes(q);
						});
						if (matchesTag && propertyHasTag) {
							groupingsMatch = true;
							html =
								html ||
								getResultHtml(
									property.link || '#',
									property.propertyName,
									tagMap[property.country],
									interactionName,
									interactionType
								);
							groupingsResults[i].push(html);
						}
					});
				}
			});
		}
		const $resultsElem = $results.children(selectors.innerResults);
		if (results.length || groupingsMatch) {
			$results.find(selectors.noResults).hide();
			if (results.length) {
				$resultsElem.html(results.join(''));
				$resultsElem.show();
			} else {
				$resultsElem.hide();
			}
			if (groupingsResults.length) {
				groupingsResults.forEach((groupingResult, i) => {
					const $grouping = $(groupings[i]);
					if (groupingResult.length) {
						const $groupResults = $grouping.children(selectors.groupResults);
						$groupResults.html(groupingResult.join(''));
						$groupResults.show();
						$grouping.show();
					} else {
						$grouping.hide();
					}
				});
			} else {
				$(groupings).hide();
			}
		} else {
			$results.find(selectors.noResults).css('display', 'flex');
			$resultsElem.hide();
			$(groupings).hide();
		}
		$results[0].scrollTop = 0;
	}
};
export default function hotelSearchBar() {
	const tabbedHero = document.querySelector(selectors.tabbedHeroContent);
	document.querySelectorAll(selectors.hotelSearchBar).forEach((searchBar, i) => {
		const withinTabbedHero = tabbedHero && tabbedHero.contains(searchBar);
		const $tabbedHero = $(selectors.tabbedHeroContent);
		const $tabbedHeroIcons = $(selectors.tabbedHeroIcons);
		const $searchBar = $(searchBar);
		const interactionName = $searchBar.data('interaction-name');
		const interactionType = $searchBar.data('interaction-type');
		const $input = $searchBar.find(selectors.input);
		const $results = $searchBar.find(selectors.results);
		const groupings = $results[0].querySelectorAll(selectors.group);
		const propertyData = $searchBar.data('search-data');
		let lastTimeOpened;
		lastq[i] = null;
		const onSearchChange = (hideResults, blockShowIfHidden) => {
			let fitSearchHeight;
			search(
				$input.val(),
				propertyData,
				groupings,
				$results,
				interactionName,
				interactionType,
				i
			);
			const fitSearch = height => {
				const step = () => {
					const searchRect = searchBar.getBoundingClientRect();
					const navHeight = getBreakpoint() === 'small' ? 110 : 150;
					let currTop = 0;
					try {
						currTop = parseInt($searchBar.css('top'), 10);
					} catch (_e) {
						currTop = 0;
					}
					if (!$searchBar.hasClass('active')) {
						gsap.to([searchBar.previousElementSibling, searchBar], {
							top: 0,
							duration: 0.3,
							ease: 'none',
						});
						// $searchBar[0].previousElementSibling.style.top = '';
						// $searchBar.css('top', '');
					} else if (searchRect.top < navHeight) {
						const top = navHeight - searchRect.top + currTop;
						$searchBar.css('top', top);
						searchBar.previousElementSibling.style.top = `${top}px`;
					}
					if ($searchBar.hasClass('active') && $results[0].offsetHeight !== height) {
						window.requestAnimationFrame(step);
					}
				};
				window.requestAnimationFrame(step);
			};
			if (hideResults && $searchBar.hasClass('active')) {
				if (window.innerWidth <= 1100) {
					$results.css({
						'max-height': 1,
						transition: 'all 0.3s linear',
					});
					setTimeout(() => {
						$results.css({
							display: '',
							transition: '',
						});
					}, 300);
				} else {
					$results.css({
						display: '',
						'max-height': '',
					});
				}
				$searchBar.removeClass('active');
				fitSearch(0);
			} else if (!$searchBar.hasClass('active') && !blockShowIfHidden && !hideResults) {
				lastTimeOpened = Date.now();
				const css = {
					display: 'block',
					transition: '',
				};
				if (window.innerWidth <= 1100) {
					css['max-height'] = 1;
					let height = getBreakpoint() === 'small' ? 250 : 315;
					fitSearchHeight = height;
					window.requestAnimationFrame(() => {
						$results.css({
							'max-height': height,
							transition: 'all 0.3s linear',
						});
					});
				} else {
					css['max-height'] = '';
				}
				$results.css(css);
				$searchBar.addClass('active');
			}
			if (withinTabbedHero) {
				resetTabHeroIcons($searchBar, $tabbedHero, $tabbedHeroIcons);

				// fix issues when keyboard opens
				if ($searchBar.hasClass('active')) {
					let height;

					if (window.innerHeight < 500) {
						height = 180;
					} else if (window.innerHeight < 1000) {
						height = 250;
					}
					if (height) {
						fitSearchHeight = height;
						window.requestAnimationFrame(() => {
							$results.css({
								'max-height': height,
							});
						});
					}
				}
			}
			if (fitSearchHeight) {
				fitSearch(fitSearchHeight);
			}
			window.dispatchEvent(new Event('hotelSearchChanged'));
		};
		window.addEventListener('tabbedHeroSwitched', () => {
			onSearchChange(true);
		});
		$searchBar.find(selectors.clearButton).on('click', () => {
			$input.trigger('focus');
			$input.val('');
			onSearchChange();
		});
		window.addEventListener(
			'resize',
			_debounce(() => {
				window.requestAnimationFrame(() => {
					onSearchChange(false, true);
				});
			}, 100)
		);
		$input[0].addEventListener('input', () => {
			onSearchChange();
		});
		$input[0].addEventListener('focus', () => {
			onSearchChange();
		});
		$input.on('click', () => {
			onSearchChange();
		});
		//Hack because safari sometimes won't navigate if the search results are closing
		let keepOpen = false;
		document.addEventListener(
			'click',
			e => {
				if (e.target?.tagName === 'A') {
					keepOpen = true;
				}
			},
			true
		);

		window.addEventListener('blur', e => {
			window.requestAnimationFrame(() => {
				const activeElement = e.relatedTarget || document.activeElement || e.target;
				let hide = activeElement !== searchBar && activeElement !== $results[0];
				if (lastTimeOpened && Date.now() - lastTimeOpened < 1000) {
					hide = false;
				} else if (hide) {
					hide =
						!searchBar.contains(activeElement) && !$results[0].contains(activeElement);
				}
				if (hide && !keepOpen) {
					onSearchChange(true);
				}
			});
		});

		window.addEventListener(
			'scroll',
			_debounce(() => {
				if (!lastTimeOpened || Date.now() - lastTimeOpened > 1000) {
					onSearchChange(true);
				}
			}, 100)
		);

		document.addEventListener('click', event => {
			const isSearchBarClicked = searchBar.contains(event.target);
			if (!isSearchBarClicked) {
				onSearchChange(true);
			}
		});

		document.addEventListener('keydown', event => {
			if (event.key === 'Escape') {
				onSearchChange(true);
			}
		});

		// don't tab through everything if no search
		document.addEventListener('keydown', function (event) {
			let code = event.key && event.key === 'Tab' ? 9 : event.keyCode || event.which;
			if (code === 9) {
				if ($searchBar.hasClass('active') && !$input.val()) {
					onSearchChange(true);
				}
			}
		});
	});
}
